<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-12">
                  <pr-input-column
                    label="Frais de dossier"
                    [derrors]="derrors"
                    [suffix]="'€'"
                  >
                    <input
                      formControlName="applicationFee"
                      type="text"
                      placeholder="200"
                    />
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <pr-input-column
                    label="Lissage des frais"
                    [derrors]="derrors"
                  >
                    <mat-select formControlName="smoothingFeesDuration">
                      @for (option of smoothingFeesDurationRef; track option) {
                        <mat-option [value]="option.id">
                          {{ option.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </div>
              @if (isDigitalInsure) {
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      label="Code génération Digital Insure"
                      [derrors]="derrors"
                    >
                      <mat-select formControlName="commDerogCode">
                        @for (option of codeConfiguration; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
